import _Reflect$construct from "@babel/runtime-corejs3/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import PropTypes from "prop-types";
import noop from "xojs/lib/callbacks/noop";
import { addEventListener, removeEventListener } from "consolidated-events";

var OutsideClickHandler = /*#__PURE__*/function (_React$Component) {
  _inherits(OutsideClickHandler, _React$Component);

  var _super = _createSuper(OutsideClickHandler);

  function OutsideClickHandler() {
    var _context;

    var _this;

    _classCallCheck(this, OutsideClickHandler);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, _concatInstanceProperty(_context = [this]).call(_context, args));

    _defineProperty(_assertThisInitialized(_this), "onOutsideClick", function (e) {
      var isDescendantOfRoot = _this.childNode.contains(e.target);

      if (!isDescendantOfRoot) {
        _this.props.onOutsideClick(e);
      }
    });

    return _this;
  }

  _createClass(OutsideClickHandler, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // `capture` flag is set to true so that a `stopPropagation` in the children
      // will not prevent all outside click handlers from firing - maja
      this.clickHandle = addEventListener(document, 'click', this.onOutsideClick, {
        capture: true
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.clickHandle) removeEventListener(this.clickHandle);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(_ref) {
          _this2.childNode = _ref;
        }
      }, this.props.children);
    }
  }]);

  return OutsideClickHandler;
}(React.Component);

export { OutsideClickHandler as default };
OutsideClickHandler.defaultProps = {
  children: /*#__PURE__*/React.createElement("span", null),
  onOutsideClick: noop
};
process.env.NODE_ENV !== "production" ? OutsideClickHandler.propTypes = {
  /**
   * Contents to wrap in outside click handler
   */
  children: PropTypes.node,

  /**
   * Callback to invoke when click outside
   */
  onOutsideClick: PropTypes.func
} : void 0;